<template>
  <div class="context-bar">
       <div class="is-canvas-toolbar"> 
            <div class="is-double-ended">
                <div class="is-left-end">
                    
                </div>
                <div class="is-right-end" style="padding-right: 20px">
                    <at-button-group size="smaller">
                        <at-button class="is-right-item" icon="icon-zoom-in" ></at-button>
                        <at-button class="is-right-item" icon="icon-zoom-out"></at-button>
                    </at-button-group>
                </div>
            </div>
        </div>
  </div>
</template>

<script>

export default {
    name: 'ContextBar',
    components: {}
}
</script>

<style>
.is-canvas-toolbar{
    height:40px; 
    background:white;
}
</style>
